import fastdom from 'fastdom';
import { partition } from 'rxjs';
import { onArticleCountResultsLoaded$ } from 'features/articleSearchResultsFacets';

const countResultsThreshold = 20;

/**
 * Pagination container element for the blog author listing.
 * This element is shown or hidden based on the total number of results.
 *
 * @type {HTMLElement | null}
 */
const paginationContainer = document.querySelector(
  '[data-component="blog-author-pagination"]'
);

/**
 * Displays the pagination component.
 * The DOM mutation is wrapped in fastdom to avoid layout thrashing.
 *
 * @returns {void}
 */
const displayNewPagination = function () {
  if (paginationContainer) {
    fastdom.mutate(() => {
      paginationContainer.removeAttribute('hidden');
    });
  }
};

/**
 * Hides the pagination component.
 * The DOM mutation is wrapped in fastdom to avoid layout thrashing.
 *
 * @returns {void}
 */
const hideCurrentPagination = function () {
  if (paginationContainer) {
    fastdom.mutate(() => {
      paginationContainer.setAttribute('hidden', '');
    });
  }
};

/**
 * Splits the article count stream into two observables:
 * - One for showing pagination when the result count exceeds the minimum page size
 * - One for hiding pagination otherwise
 */
const [
  displayNewPagination$,
  hideCurrentPagination$
] = partition(
  onArticleCountResultsLoaded$,
  (countResults) => countResults > countResultsThreshold
);

/**
 * Subscribes to pagination visibility changes.
 */
displayNewPagination$.subscribe(displayNewPagination);
hideCurrentPagination$.subscribe(hideCurrentPagination);
